import { ThemeOverride } from "@chakra-ui/react";

const styles: ThemeOverride['styles'] = {
  global: () => ({
    body: {
      bg: '#141E30',
      color: '#e2e8f0',
    },
  }),
};

export default styles;
